import { AppstoreOutlined } from '@ant-design/icons';
import { lazyRouteComponent } from '@tanstack/react-router';

import { ACCOUNT_ROLE_CODES } from '@lib/types';
import { Route } from '@lib/types/route';

import { ROUTE_PATHS } from '../route-paths';

const InventoryAdminPage = lazyRouteComponent(() => import('./pages/admin'));

const StoreFolderPage = lazyRouteComponent(
  () => import('./pages/store-folder'),
);

const MultipleRegistrationPage = lazyRouteComponent(
  () => import('./pages/multiple-registration'),
);

const BulkPricePage = lazyRouteComponent(() => import('./pages/bulk-price'));
const PromotionsPage = lazyRouteComponent(() => import('./pages/promotions'));

export const getRoutes = (): Route[] => [
  {
    page: MultipleRegistrationPage,
    path: ROUTE_PATHS.INVENTORY_MULTIPLE_REGISTRATION,
    title: 'Cadastro múltiplo',
    hidden: true,
  },
  {
    page: BulkPricePage,
    path: ROUTE_PATHS.INVENTORY_BULK_PRICE,
    title: 'Atualização de preços em massa',
    hidden: true,
  },
  {
    page: PromotionsPage,
    path: ROUTE_PATHS.STORE_PROMOTIONS,
    title: 'Promoções',
    hidden: true,
  },
  {
    page: InventoryAdminPage,
    path: ROUTE_PATHS.ADMIN_INVENTORY,
    title: 'Inventário e catálogo',
    icon: AppstoreOutlined,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
    adminSection: 'catalog',
    adminOrder: 10,
  },
  {
    page: StoreFolderPage,
    path: ROUTE_PATHS.LEGACY_STORE_FOLDER,
    redirectTo: ROUTE_PATHS.STORE_FOLDER,
    title: 'Loja',
    hidden: true,
    public: true,
  },
  {
    page: StoreFolderPage,
    path: ROUTE_PATHS.STORE_FOLDER,
    title: 'Loja',
    hidden: true,
    public: true,
  },
];
